import React, { useState, useEffect, useRef } from 'react';
import '../styles/StatsSection.css';

function StatCounter({ target, label, duration = 2000 }) {
  const [count, setCount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !isVisible) {
        setIsVisible(true);
      }
    });

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, [isVisible]);

  useEffect(() => {
    if (!isVisible) return;

    let start = 0;
    const increment = target / (duration / 50);
    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 50);

    return () => clearInterval(timer);
  }, [isVisible, target, duration]);

  return (
    <div ref={ref} className="stat-counter">
      <div className="stat-number">{count}+</div>
      <p className="stat-label">{label}</p>
    </div>
  );
}

function StatsSection() {
  return (
    <section className="stats-section">
      <div className="stats-container">
        <div className="stats-grid">
          <StatCounter target={10} label="Years Experience" />
          <StatCounter target={150} label="Projects Completed" />
          <StatCounter target={150} label="Satisfied Clients" />
          <StatCounter target={10} label="Awards & Recognition" />
        </div>
      </div>
    </section>
  );
}

export default StatsSection;